export default requester => {
    return {
        /**
         * Moderate a user.
         *
         * @param {object} data
         * @return {Promise}
         */
        moderate: (data) => {
            return requester.post('/acl/moderations/users', data);
        },
        
        /**
         * Get moderation permissions.
         *
         * @param {object} data
         * @return {Promise}
         */
        permissions: (data) => {
            // return Promise.resolve({
            //     data: {
            //         "data": {
            //             "actions": [
            //                 {
            //                     "action": "chat.topic.create",  // API uses dot notation
            //                     "result": "allowed"
            //                 }
            //             ],
            //             "moderations": null,
            //             "action_token": "dummy-token"
            //         }
            //     }
            // });
            return requester.post(`/acl/permissions?id=${data.id}`, data);
        },

        /**
         * Get moderation users (banned users) for a platform.
         *
         * @param {object} params - platform_id, status, page, size, user_id
         * @return {Promise}
         */
        moderationUsers: (params) => {
            return requester.get('/users/moderations', { params });
        },
    };
}
